

const __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))((resolve, reject) => {
    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
    function rejected(value) { try { step(generator.throw(value)); } catch (e) { reject(e); } }
    function step(result) { result.done ? resolve(result.value) : new P((resolve) => { resolve(result.value); }).then(fulfilled, rejected); }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const __generator = (this && this.__generator) || function (thisArg, body) {
  let _ = { label: 0, sent: function () { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] },
    f,
    y,
    t,
    g;
  return g = { next: verb(0), throw: verb(1), return: verb(2) }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
    if (f) throw new TypeError('Generator is already executing.');
    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? 'return' : op[0] ? 'throw' : 'next']) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];
        switch (op[0]) {
          case 0: case 1: t = op; break;
          case 4: _.label++; return { value: op[1], done: false };
          case 5: _.label++; y = op[1]; op = [0]; continue;
          case 7: op = _.ops.pop(); _.trys.pop(); continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
            if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
            if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
            if (t[2]) _.ops.pop();
            _.trys.pop(); continue;
        }
        op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
    }
    if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
};
Object.defineProperty(exports, '__esModule', { value: true });
const command_1 = require('../libs/command');

const pcWeb = /** @class */ (function () {
  function pcWeb(runtimeName) {
    this.name = runtimeName;
    if (!window.jsBridge) {
      window.jsBridge = {};
    } else {
      alert('挂载API出错!');
    }
    console.warn('current app run on the ', runtimeName);
  }
    /**
     * PC环境下无需任何配置，空函数
     * @description
     */
  pcWeb.prototype.config = function () {
  };

    /**
   * 在PC环境下关闭掉H5页面
   *
   */
  pcWeb.prototype.closeWindow = function () {
    console.log('关闭网页成功');
  };
    /**
     * 调用微信sdk支付功能
     *
     * @param {Runtime.PayData} params
     * @returns {Promise}
     */
  pcWeb.prototype.chooseWXPay = function (params) {
    return new Promise((resolve, reject) => {
      resolve('已获取支付参数');
    });
  };
    /**
     * 在PC环境下设置导航栏
     *
     * @param {Runtime.DwdTitleData} params
     */
  pcWeb.prototype.setHeader = function (params) {
    return new Promise((resolve, reject) => {
      resolve('设置导航栏成功');
    });
  };

    /**
     * 在PC环境下跳转订单详情,空函数
     *
     * @param {Runtime.DwdGoToShopOrderData} params
     */
  pcWeb.prototype.gotoShopOrderDetail = function (params) {
    return new Promise((resolve, reject) => {
      resolve('跳转订单详情成功');
    });
  };
    /**
     * 在PC环境下提交追加单取消原因
     *
     * @param {Runtime.DwdAppendOrderCancelReason} params
     */
  pcWeb.prototype.submitAppendOrderCancelReason = function (params) {
    return new Promise((resolve, reject) => {
      resolve('提交取消原因成功');
    });
  };
    /**
     * 在PC环境下调用打电话
     *
     * @param {Runtime.DwdCallPhone} params
     */
  pcWeb.prototype.callPhone = function (params) {
  };
    /**
     * 在PC环境下获取网络类型
     *
     */
  pcWeb.prototype.getNetworkType = function () {
    return new Promise((resolve, reject) => {
      resolve('wifi');
    });
  };
    /**
     * 在PC环境下打开外部浏览器
     *
     * @param {Runtime.DwdOpenBrowserData} params
     */
  pcWeb.prototype.openExternalBrowser = function (params) {
    window.open(params.url);
  };
    /**
     * 在PC环境下复制到剪切板
     *
     * @param {Runtime.DwdCopyToClipData} params
     */
  pcWeb.prototype.copyToClipBoard = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      let text;
      return __generator(this, (_a) => {
        text = (params || { text: '' }).text;
        return [2 /* return */, command_1.copy(text)];
      });
    });
  };
    /**
     * 在PC环境下从剪切板获取文本
     *
     */
  pcWeb.prototype.pasteFromClipBoard = function () {
  };
    /**
     * 在PC环境下暂停音频
     *
     * @param {any} element
     */
  pcWeb.prototype.pauseAudio = function (element) {
    element.pause();
        // 保证下次play的时候能够从头开始播放
    element.currentTime = 0;
  };

    /**
     * 在PC环境下播放音频
     *
     * @param {any} element
     */
  pcWeb.prototype.playAudio = function (element) {
    element.play();
  };

    /**
     * PC环境下分享给朋友功能
     *
     * @param {Runtime.MessageShareData} params
     * @returns {Promise}
     */
  pcWeb.prototype.shareToFriends = function (params) {
    return new Promise((resolve, reject) => {
      resolve('分享成功');
    });
  };

    /**
     * PC环境下的扫码功能，其实是返回者指环境下定的数据
     *
     * @param {Runtime.ScanQRCodeData} params
     * @returns {Promise}
     */
  pcWeb.prototype.scanQRCode = function (params) {
    return new Promise((resolve, reject) => resolve(params.mockData));
  };

    /**
     * PC环境下获取地理位置功能
     *
     * @param {Runtime.GetLocationParam} params
     * @returns {Promise}
     */
  pcWeb.prototype.getLocation = function (params) {
    return new Promise((resolve, reject) => resolve({
      longitude: params.mockData[0],
      latitude: params.mockData[1]
    }));
  };

    /**
     * PC环境下打开地理位置功能
     *
     * @param {Runtime.LocationData} location
     * @returns {Promise}
     */
  pcWeb.prototype.openLocation = function (params) {
    return new Promise((resolve, reject) => resolve('打开地图成功'));
  };

    /**
     * PC环境下获取图片功能
     *
     * @param {Runtime.ChooseImageData} params
     * @returns {Promise}
     */
  pcWeb.prototype.chooseImage = function (params) {
    return new Promise((resolve, reject) => resolve('选择图片成功'));
  };

    /**
     * PC环境下上传图片功能
     *
     * @param {Runtime.UploadResource} params
     * @returns {Promise}
     */
  pcWeb.prototype.uploadImage = function (params) {
    return new Promise((resolve, reject) => resolve('上传图片成功'));
  };
    /**
    * 点我达APP打开一个对话框
    *
    * @param {Runtime.DwdDialogData} params
    */
  pcWeb.prototype.showDialog = function (params) {
  };
    /**
     * 点我达APP Native页面跳转
     *
     * @param {Runtime.DwdForwardToNativeData} params
     */
  pcWeb.prototype.forwardToNative = function (params) {
    return new Promise((resolve, reject) => resolve({ couponId: 232, couponValue: 100, isCanncel: 0 }));
  };
  pcWeb.prototype.takeAndUploadPicture = function (params) {
  };
  pcWeb.prototype.httpRequest = function (params) {
  };
  pcWeb.prototype.setTitle = function (params) {
  };
  pcWeb.prototype.uploadBase64 = function (params) {
  };
    /**
     * PC环境下获取Native信息
     *
     * @param {Runtime.GetNativeDataParam} params
     * @returns {Promise}
     */
  pcWeb.prototype.getNativeData = function (params) {
    return new Promise((resolve, reject) => resolve(params.mockData));
  };

    /**
   * 点我达APP下webview监听消息
   *
   * @param {Runtime.onMessageParam} params
   * @returns {Promise}
   */
  pcWeb.prototype.onMessage = function (params) {
    return new Promise((resolve, reject) => resolve(params.mockData));
  };

    /**
     * 点我达APP下webview发送消息给别的webview
     *
     * @param {Runtime.postMessageParam} params
     * @returns {Promise}
     */
  pcWeb.prototype.postMessage = function (params) {
    return new Promise((resolve, reject) => resolve('发送事件成功'));
  };

    /**
     * 点我达APP下H5通知native某些事件
     *
     * @param {Runtime.notifyNativeParam} params
     * @returns {Promise}
     */
  pcWeb.prototype.notifyNative = function (params) {
    return new Promise((resolve, reject) => resolve('通知native成功'));
  };

    /** native 方法，拍照上传 */
  pcWeb.prototype.takePhotoAndUploadWithTips = function () { return Promise.resolve(); };

    /**
     * 是否支持微信支付
     */
  pcWeb.prototype.getSupportWXPay = function () { return Promise.resolve(); };

    /**
     * 微信支付
     */
  pcWeb.prototype.startWechatPay = function (params) {
    return Promise.resolve();
  };
    /**
   * 支付宝支付
   */
  pcWeb.prototype.startAliPay = function (params) {
    return Promise.resolve();
  };
    /**
     * 支付宝新SDK支付
     */
  pcWeb.prototype.startAliPayUrl = function (params) {
    return Promise.resolve();
  };
    /**
     * @description native 链接跳转方法
     * @param params url:native链接
     */
  pcWeb.prototype.dwdRoute = function (params) {
  };
  return pcWeb;
}());
exports.pcWeb = pcWeb;
